/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  Link,
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
} from 'react-router-dom'
import { Home } from '@lmc/ts-common'
import { SettingsSidebarNavigation } from './components'
import { getNavigationTabs } from './utils'
import { useSelector } from 'react-redux'
import get from 'lodash/get'
import styled from 'styled-components'
import { isBrowser, isTablet } from 'react-device-detect'
import { EmptyState, NotFoundIcon } from '@lmc/ui-kit'
import { CustomMenuItemType } from 'utils'
import useFeatureFlags from 'hooks/useFeatureFlags'
import useHomeType from 'hooks/useHomeType'

const StyledContainer = styled.div`
  display: flex;
  height: calc(100vh - 64px);
  max-width: 2000px;
  width: 100%;
`

const StyledRightContainer = styled.div`
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  width: 100%;
  margin: 0 auto;
`

export const AccountsSettingsScreen = () => {
  const role = useSelector((state) => get(state, 'global.user.role'))
  const { hasRota } = useHomeType()
  const features = useSelector(
    (state: { global: { home: Home } }) => state.global.home,
  )

  const navigate = useNavigate()

  const location = useLocation()

  const flags = useFeatureFlags({
    flagNames: [
      'rostering_tolerance_settings',
      'travel_and_mileage',
      'geofencing',
      'mods_needs_settings',
      'payrates',
      'invoicing',
    ],
  })?.data
  const flagsRosteringToleranceSettings =
    flags?.rostering_tolerance_settings?.enabled

  const flagsTravelTimeAndMileageEnabled = flags?.travel_and_mileage?.enabled

  const flagsGeofencingEnabled = flags?.geofencing?.enabled

  const flagsModsNeedsSettings = flags?.mods_needs_settings?.enabled

  const flagsPayRatesEnabled = flags?.payrates?.enabled

  const flagsInvoicingEnabled = flags?.invoicing?.enabled

  if (role === 'senior-carer') {
    return (
      <EmptyState
        title="We cant find what you’re looking for... Error 404"
        description="Don’t worry, try refreshing the page and if the problem persists contact support."
        icon={<NotFoundIcon />}
      >
        <Link to="/">Go back home</Link>
      </EmptyState>
    )
  }

  const navigationKey =
    location.pathname !== '/settings'
      ? location?.pathname?.split('settings/')[1]
      : '/reports/billing'

  return (
    <StyledContainer>
      {isDesktop && (
        <SettingsSidebarNavigation
          navigationKey={navigationKey}
          navigate={navigate}
          menuItems={
            getNavigationTabs(
              features,
              role!,
              hasRota,
              flagsRosteringToleranceSettings,
              flagsTravelTimeAndMileageEnabled,
              flagsGeofencingEnabled,
              flagsModsNeedsSettings,
              flagsPayRatesEnabled,
              flagsInvoicingEnabled,
            ) as CustomMenuItemType[]
          }
        />
      )}
      <StyledRightContainer>
        {location.pathname === '/settings' ? (
          <Navigate to="billing" />
        ) : location.pathname === '/settings/skills-and-needs' &&
          flagsModsNeedsSettings ? (
          <Navigate to="skills-and-needs/skill-templates" replace />
        ) : location.pathname.startsWith('/settings/skills-and-needs/') &&
          flagsModsNeedsSettings === false ? (
          <Navigate to="/settings/skills-and-needs" replace />
        ) : (
          <Outlet />
        )}
      </StyledRightContainer>
    </StyledContainer>
  )
}

const isDesktop = isBrowser || isTablet

export default AccountsSettingsScreen
